import { PageRequest } from '@/route-handlers/page-request';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import LoadingSpinner from '@ui/loading-spinner/loading-spinner';
import { Suspense } from 'react';
import { Await, Link, Navigate, useLoaderData } from 'react-router';

const LoadingView: React.FC = () => {
  return (
    <div className="form-page-container gap-16 flex-column">
      <h4 className="text-center">Logging out...</h4>

      <LoadingSpinner style={{ transform: 'scale(0.8)' }} />
    </div>
  );
};

const ErrorView: React.FC<unknown> = () => {
  const searchParams = PageRequest.fromSearchParams(new URL(window.location.href).searchParams);
  return (
    <div className="form-page-container gap-16 flex-column">
      <h4 className="text-center">Log out error</h4>
      <div className="flex-center">
        <Icon name={ICONS.EXCLAMATION_MARK} size={48} color={'error'} />
      </div>
      <p>We're unable to log you out. Please refresh to try again.</p>
      <div className="form-actions-row">
        <Link className="button auth-resource-link" to={'/sign-in?' + searchParams.toParams()}>
          Go to Login
        </Link>
      </div>
    </div>
  );
};
const Logout: React.FC = () => {
  const { redirect } = useLoaderData() as { redirect: () => Promise<Response> };
  // all sign in logic is handled in the sso-redirect route handler
  return (
    <Suspense fallback={<LoadingView />}>
      <Await errorElement={<ErrorView />} resolve={redirect}>
        {(response) => {
          return <Navigate to={response.redirect} />;
        }}
      </Await>
    </Suspense>
  );
};

export default Logout;
